<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des consignes par NIR</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="nir" slot-scope="props">
            <span :id="`tooltip-nir-${props.row.id}`">{{ props.row.nir.length > 29 ? props.row.nir.substring(0,29) + '...' : props.row.nir }}</span>
            <b-tooltip v-if="props.row.nir.length > 29" :target="`tooltip-nir-${props.row.id}`" triggers="hover" placement="top">{{ props.row.nir }}</b-tooltip>
          </div>
          <div slot="commentaire" slot-scope="props">
            <span :id="`tooltip-commentaire-${props.row.id}`">{{ !isCommentaireEmpty(props.row.commentaire) ? (props.row.commentaire.length > 407 ? props.row.commentaire.substring(0,403) + '...' : props.row.commentaire) : props.row.commentaire }}</span>
            <b-tooltip v-if="!isCommentaireEmpty(props.row.commentaire) && props.row.commentaire.length > 407" :target="`tooltip-commentaire-${props.row.id}`" triggers="hover" placement="top">{{ props.row.commentaire }}</b-tooltip>
          </div>
          <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.created_at) }}</span>
          </div>
          <div v-if="props.row.updated_at" slot="updated_at" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDateHeure(props.row.updated_at) }}</span>
          </div>
           <div v-if="props.row.date_debut" slot="date_debut" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_debut) }}</span>
          </div>
          <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_fin) }}</span>
          </div>
          <div slot="action" slot-scope="props">
            <i class="fa fa-pencil mr-2 text-primary clickable" @click="edit(props.row.id)"></i>
            <i class="fa fa-trash clickable text-danger" @click.prevent="destroy(props.row.id)"></i>
          </div>
        </v-client-table>
      </b-card-body>

      <div slot="footer">
        <b-button v-if="canExtract(rules.EXTRACT_CONSIGNES_NIR)" type="button" size="md" variant="success">
          <i class="fa fa-file-excel-o"></i>&nbsp;<a @click="downloadConsignesNir" class="bleu_clair">Exporter en Excel</a><br>
        </b-button>
        <b-button type="button" @click="edit('')" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une consigne
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import { isEmpty, downloadFile } from "@/utils/fileHelper";
  import { formatDateTime } from "@/utils/communHelper";
  import { espaceGestionRules, hasRule } from "@/utils/rulesHelper";
  import moment from 'moment';

  export default {
    name: "List",
    data() {
      return {
        columns: ['created_at', 'nir', 'commentaire', 'date_debut', 'date_fin', 'updated_at', 'action'],
        data: [],
        options: {
          headings: {
            'created_at': 'Date de création',
            'nir': 'NIR',
            'date_debut': 'Date début',
            'date_fin': 'Date fin',
            'updated_at': 'Date de modif.',
          },
          columnsClasses: {
            action: 'pre-formatted sort-top position-r action-xs',
            // commentaire: 'text-left',
            'nir': 'action-md',
            'created_at': 'action-xs pre-formatted',
            'updated_at': 'action-xs pre-formatted',
            'date_debut': 'action-xs pre-formatted',
            'date_fin': 'action-xs pre-formatted'
          },
          rowClassCallback(row) {
            if (row.date_fin !== null) {
              let dateFin = new Date(row.date_fin).getTime()
              let today = new Date().getTime()
              return dateFin < today ? 'desactive' : ''
            }
          },
          filterable: ['nir'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "NIR"
          },
          sortable: ['created_at', 'nir', 'updated_at'],
        },
        rules: espaceGestionRules,
      }
    },
    mounted() {
      this.all();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      all() {
        this.$axios
          .get("/espaceGestion/consignes-nir")
          .then(response => {
            this.data = response.data.consignesNir;
          })
          .catch((error) => {
            console.log(error)
            this.handleError(this);
          });
      },
      destroy(id) {
        let self = this;
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette consigne ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .delete("/espaceGestion/consignes-nir/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La consigne a bien été supprimée",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  this.handleError(self);
                })
            }
          })

      },
      edit(id) {
        this.$router.push({path: '/espace-gestion/consignes-nir/edit/', query: {id: id}})
      },
      handleError(self) {
        self.$store.commit("IS_LOADING", false);
        self.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support Dosi.',
          showConfirmButton: false,
          timer: 5000
        });
      },
      formatDateHeure(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleString("fr-FR") : "-";
        return date;
      },
      formatDate(textDate) {
        return textDate !== null ? moment(textDate).format('DD/MM/YY') : "-";
      },
      isCommentaireEmpty(commentaire) {
        return isEmpty(commentaire);
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
      canExtract(rule) {
        return hasRule(rule)
      },
      downloadConsignesNir() {
        let url = 'extract_consignes_nir'
        let filename = 'consignes_nir'
        let extension = 'csv'
        let self = this
        extension = isEmpty(extension) ? 'csv' : extension;

        this.$store.commit('IS_LOADING', true);
        this.$axios.get(`/espaceGestion/extractions/${url}`, {responseType: 'blob'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, filename, extension);
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            let errorText = "Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI."
            if (error.response.status === 403) {
              errorText = "Vous n'êtes pas autorisé à effectuer cette action"
            }
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
    }
  }
</script>
